import { render } from "./BuyToken.vue?vue&type=template&id=1c379b41"
import script from "./BuyToken.vue?vue&type=script&lang=js"
export * from "./BuyToken.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__